import { render, staticRenderFns } from "./payment-form.vue?vue&type=template&id=23af68ca&scoped=true&"
import script from "./payment-form.vue?vue&type=script&lang=js&"
export * from "./payment-form.vue?vue&type=script&lang=js&"
import style0 from "./payment-form.vue?vue&type=style&index=0&id=23af68ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23af68ca",
  null
  
)

export default component.exports